/* eslint-disable */
import $ from 'jquery';
import '../../../source/javascripts/vendor/admin/vendor/jquery.history-1.8.0b2';
import openWindow from '../utils/openWindowUtils';
import getNoCacheRandomString from '../utils/URLUtiles';
import message from '../../utils/message';

const {
  showSearchCriteria,
  hideSearchCriteria,
} = message
console.warn(showSearchCriteria)
/**
 * クラス管理者が受講者のパスワードを初期化する
 */
function passwd_init(no){
  if (confirm(message.resetPassword+' '+message.isItOK) == false) {
    return;
  }
  $.getJSON("../../flash/passwd_init.cfc?method=fnc_passwd_init", {
    "user_id": no,
    _CF_NODEBUG: true,
    rand: getNoCacheRandomString()
  }, function endInit(json) {
    if (json["success"]) {
      alert(message.passwordChanged + '\n\n' + json["result"] + '\n\n' + message.tellStudentPassword);
    } else {
      alert(message.passwordResetError + '\n\n' + json["err_msg"]);
    }
  });
}
function list_zebra() {


}
/**
 * リストが読み込まれた時に実行する処理を入れる
 */
function onLoadInfoList() {
  //通常は、なにもしない
  //TODO 利用する場合はオーバーライドすること
}
/**
 * 検索ボタン押下時
 * @param {Object} form_nm
 * @param {Object} url
 */
function list_search(form_nm, url) {
  /*
   * Form の内容を更新
   */
  $("#pg").val(1);
  searchStrObject = $("#" + search_target_form_nm).serializeArray();
  /*
   * Hashを作成してプラグインに渡す
   */
  var hash = "#" + $("#" + search_target_form_nm).serialize();
  hash = hash.replace(/^.*#/, '');
  $.historyLoad(hash);
}
/** 検索用のForm */
var search_target_form_nm = "";
/** 検索用のURL */
var search_target_url = "";
/** 検索条件を保持する */
var searchStrObject;
/**
 * History プラグインから呼ばれる
 *
 * PageLoad function
 * This function is called when:
 * 1. after calling $.historyInit();
 * 2. after calling $.historyLoad();
 * 3. after pushing "Go Back" button of a browser
 *
 * @param {Object} hash
 */
function pageload(hash) {
  var searchStr = "";
  // hash doesn't contain the first # character.
  if (hash) {
    /*--------------------------------------------------
     * ハッシュあり
     --------------------------------------------------*/
    // restore ajax loaded state
    if ($.browser.msie) {
      // jquery's $.load() function does't work when hash include special characters like aao.
      hash = encodeURIComponent(hash);
    }
    searchStr = hash;
    //alert("1::"+searchStr);
    //Formを復帰する
    if ($.browser.msie) {
      $("#" + search_target_form_nm).deserialize(
        $.string(decodeURIComponent(searchStr)).toQueryParamsEncodeHankakuSpace()
      );
    } else {
      $("#" + search_target_form_nm).deserialize(
        $.string(searchStr).toQueryParamsEncodeHankakuSpace()
      );
    }
  } else {
    /*--------------------------------------------------
     * ハッシュなし
     --------------------------------------------------*/
    //初期値をセット
    $("#pg").val(1);
    searchStr = $("#" + search_target_form_nm).serialize();
  }
  //alert("2::"+searchStr);
  /*--------------------------------------------------
   * ページング
   --------------------------------------------------*/
  //ブラウザキャッシュ対策：乱数を付与する
  searchStr += "&ran=" + getNoCacheRandomString();
  if ($.browser.msie) {
    searchStr = decodeURIComponent(searchStr);
    //searchStr = encodeURI(searchStr);	// 日本語だけをencodeするために必要
  }
  var url = search_target_url + "?" + searchStr;
  $("#info_list").load(url, null, function() {
    onLoadInfoList();
  });
}

/**
 * 【使わないこと　複数のチャックボックスのチェックが消える】ハッシュの配列をハッシュに変換する
 *
 * [{name:"",value:""},{name:"",value:""}]
 * ↓
 * {name:value,name:value,name:value}
 */
function getHashToArray(array) {
  var param = {};
  $(array).each(function(i, v) {
    param[v.name] = v.value;
  });
  return param;
}
/**
 * ハッシュの複製を返す
 * getHashToArray() のバグがあったため、影響範囲を少なくするために複製することにした。
 */
function getCopyHash(array) {
  var copy = [];
  $(array).each(function(i, v) {
    copy.push({'name': v.name, 'value': v.value});
  });
  return copy;
}
/**
 * ハッシュの値を返す。
 */
function getHashArrayValue(key) {
  var currentHash = $.historyCurrentHash;
  if (currentHash != null) {
    var params = $.historyCurrentHash.split("&");
    for (var i = 0; i < params.length; i++) {
      var keyVal = params[i].split("=");
      if (keyVal[0] == key && keyVal.length == 2) {
        return decodeURIComponent(keyVal[1]);
      }
    }
  }
  return null;
}
/**
 * [{name:"",value:""},{name:"",value:""}]形式の配列の値を
 * 名前を指定して、置換する
 *
 * 【注意】nameは一意であること
 *
 * @param array
 * @param name
 * @param value
 * @return
 */
function arrayChangeNameValue(array, name, value) {
  $(array).each(function(i, v) {
    if (v.name == name) {
      v.value = value;
      return false
    }
  });
}
/**
 * ページ表示後にプルダウンを作成し値を選択した場合に、searchStrObjectを再セットする
 * @author tajima
 */
function reset_searchStrObject() {
  searchStrObject = $("#" + search_target_form_nm).serializeArray();
}
/**
 * ページング
 * @param {Object} form_nm
 * @param {Object} url
 * @param {Object} pg
 */
function list_paging(pg) {

  /*
   * Form の内容を更新
   */
  var srt = $("#srt").val();
  var srt_ad = $("#srt_ad").val();
  //$("#pg").val(pg);
  //$("#srt").val(srt);
  //$("#srt_ad").val(srt_ad);
  /*
   * ソート条件、ページ番号を変更する（検索条件は変更しない）
   */
  var param = getCopyHash(searchStrObject);
  arrayChangeNameValue(param, "srt", srt);
  arrayChangeNameValue(param, "srt_ad", srt_ad);
  arrayChangeNameValue(param, "pg", pg);
  /*
   * Hashを作成してプラグインに渡す
   */
  var hash = "#" + $.param(param);
  hash = hash.replace(/^.*#/, '');
  $.historyLoad(hash);
}
/**
 * ソート
 * @param {Object} form_nm
 * @param {Object} url
 * @param {Object} srt
 */
function list_sort(srt) {
  /*
   * Form の内容を更新
   */
  var srt_ad = "asc";
  if ($("#srt").val() == srt) {
    if ($("#srt_ad").val() == "desc") {
      srt_ad = "asc";
    } else {
      srt_ad = "desc";
    }
  }
  // 戻ってきた時用
  //$("#pg").val('1');
  //$("#srt").val(srt);
  //$("#srt_ad").val(srt_ad);
  /*
   * ソート条件、ページ番号を変更する（検索条件は変更しない）
   */
  var param = getCopyHash(searchStrObject);
  arrayChangeNameValue(param, "srt", srt);
  arrayChangeNameValue(param, "srt_ad", srt_ad);
  arrayChangeNameValue(param, "pg", 1);
  /*
   * Hashを作成してプラグインに渡す
   */
  var hash = "#" + $.param(param);
  hash = hash.replace(/^.*#/, '');
  $.historyLoad(hash);
}
/*
 * search_formの表示、非表示を切り替えた時にHashを作成してプラグインに渡す
 */
function re_load() {
  var param = getCopyHash(searchStrObject);
  var srt = $("#srt").val();
  var srt_ad = $("#srt_ad").val();
  var pg = $("#pg").val();
  arrayChangeNameValue(param, "srt", srt);
  arrayChangeNameValue(param, "srt_ad", srt_ad);
  arrayChangeNameValue(param, "pg", pg);
  var hash = "#" + $.param(param);
  hash = hash.replace(/^.*#/, '');
  $.historyLoad(hash);
  //alert(1);
}
/*
 * search_formの表示、非表示を切り替えた時にHashを作成してプラグインに渡す
 */
function search_form_dsp(dsp) {
  var param = getCopyHash(searchStrObject);
  var srt = $("#srt").val();
  var srt_ad = $("#srt_ad").val();
  var pg = $("#pg").val();
  arrayChangeNameValue(param, "srt", srt);
  arrayChangeNameValue(param, "srt_ad", srt_ad);
  arrayChangeNameValue(param, "pg", pg);
  arrayChangeNameValue(param, "dsp", dsp);
  var hash = "#" + $.param(param);
  hash = hash.replace(/^.*#/, '');
  $.historyLoad(hash);
}
function toggle_searchbox() {
  $('#toggleSearchBox').each((index, domEle) => {


    // TODO とりあえず、最初は検索フォームを非表示にする
    $(domEle).css("display", "none");
    var viewSearchOptionAreaButton = $('<a id="viewSearchOptionAreaButton" href="#">sss</a>');
    // ($("#dsp").val() == 0)
    if ($(domEle).css("display") == "none") {
      viewSearchOptionAreaButton.text(showSearchCriteria)
      viewSearchOptionAreaButton.click(()=> {
        if ($(domEle).css("display") == "none") {
          $(domEle).show();
          viewSearchOptionAreaButton.text(hideSearchCriteria);
          // Hashを作成してプラグインに渡す
          search_form_dsp('1');
        } else {
          $(domEle).hide();
          viewSearchOptionAreaButton.text(showSearchCriteria);
          // Hashを作成してプラグインに渡す
          search_form_dsp('0');
        }
      });
    } else {
      viewSearchOptionAreaButton.text(hideSearchCriteria)
      viewSearchOptionAreaButton.click(()=> {
        if ($(domEle).css("display") == "none") {
          $(domEle).show();
          viewSearchOptionAreaButton.text(hideSearchCriteria);
          // Hashを作成してプラグインに渡す
          search_form_dsp('1');
        } else {
          $(domEle).hide();
          viewSearchOptionAreaButton.text(showSearchCriteria);
          // Hashを作成してプラグインに渡す
          search_form_dsp('0');
        }
      });
    }
    $(domEle).before(viewSearchOptionAreaButton);
  });
}
/**
 * @author takeo
 */
$(function() {
  console.log("-----------------------");
  /**
   * input textのサイズをスタイルシートで指定
   */
  $(":text[size]").each(function(index, Element) {
    var $textInput = $(Element);
    var size = $textInput.attr("size");
    size = Math.floor(size / 2);
    $textInput.css("width", size + "em");
    console.log("size:" + size);
    //  $(Element).hide();
  });
  /**
   * textareaのサイズをスタイルシートで指定
   */

  $('textarea').each(function(index, Element) {
    var $textInput = $(Element);
    var size = $textInput.attr("cols");
    size = Math.floor(size / 2);
    $textInput.css("width", size + "em");
    console.log("size:" + size);
    //  $(Element).hide();
  });
  /**
   * ボタンのCSSをBootstrapへ変更
   */
  $(".actionButton").each(function(index, Element) {
    var $button = $(Element);
    $button.removeClass("actionButton");
    $button.addClass("btn");
  });
  $(".actionButton_s").each(function(index, Element) {
    var $button = $(Element);
    $button.removeClass("actionButton_s");
    $button.addClass("btn");
    $button.addClass("btn-small");
  });
  /*
   * ドロップダウンメニュー
   */
  $("div#globalMenu>ul>li").hover(
    function() {
      var w_w = $(document).width();
      var menu_w = $("ul", this).width();
      var margin = 23;
      $("ul", this).show();
      $(this).addClass("openGlobalMenu");
      console.log($("ul", this).offset());
      console.log($("ul", this).offset().left + ":" + (w_w - (menu_w + margin)));
      if ($("ul", this).offset().left > w_w - (menu_w + margin)) {
        $("ul", this).css("left", w_w - (menu_w + margin));
      }
    },
    function() {
      $("ul", this).hide();
      $(this).removeClass("openGlobalMenu");
    }
  );



  /* ajax使用しない場合の検索条件BOX */
  $('#toggleSearchBox2').each(function(index, domEle) {

    const $searchBox = $(domEle);
    let isShowSearchBox = false;

    // 初期ロード時
    if($("#dsp").val() === '1'){
      isShowSearchBox = true;
    }

    if (!isShowSearchBox) {
      $searchBox.hide();
    }

    var $viewSearchOptionAreaButton = $('<a id="viewSearchOptionAreaButton" href="#"></a>');

    if (!isShowSearchBox) {
      $viewSearchOptionAreaButton.text(showSearchCriteria);
    } else {
      $viewSearchOptionAreaButton.text(hideSearchCriteria);
    }

    $viewSearchOptionAreaButton.click((e) => {
      e.preventDefault();

      if($("#dsp").val() === '1'){
        // 検索ボックスが表示されている場合
        $searchBox.hide();
        $("#dsp").val('0');
        $viewSearchOptionAreaButton.text(showSearchCriteria);
      } else {
        // 検索ボックスが隠れている場合
        $searchBox.show();
        $("#dsp").val('1');
        $viewSearchOptionAreaButton.text(hideSearchCriteria);
      }

    });

    $(domEle).before($viewSearchOptionAreaButton);
  });
});

//お知らせを隠す
function hideNewsArea() {
  $("#newsArea").fadeOut(500, function() {
    $("#newsArea_speser").animate({height: "0px"});
  });
}
//お知らせを表示
function showNewsArea() {
  $("#newsArea_speser").animate({height: "150px"}, function() {
    $("#newsArea").fadeIn(1000);
  });
}

/**
 * 「カートに追加」ボタンを押した時の処理
 * @param title
 * @param url
 * @param type
 */
function onClickAddToCartButton(title, url, type) {
  // course-materials-cartjsが公開しているaddItemToCart関数を呼ぶ
  window.addItemToCart({
    title: title,
    url: url,
    type: type,
  });
}
/**
 * ページ表示時
 * @param {Object} form_nm
 * @param {Object} url
 */
let on_load = (form_nm, url) => {
  search_target_form_nm = form_nm;
  search_target_url = url;
  // history pluginの初期化
  // TODO APIが変わっていたのでとりあえず、コメントアウト
  // $.historyInit(pageload, url);
  searchStrObject = $("#" + search_target_form_nm).serializeArray();
  toggle_searchbox();
  var dsp = $("#dsp").val();
  if (dsp == 1) {
    $("#toggleSearchBox").show();
  } else {
    $("#toggleSearchBox").hide();
  }
}

export  {
  on_load,
  passwd_init,
  onLoadInfoList,
  list_search,
  pageload,
  getNoCacheRandomString,
  getHashToArray,
  getCopyHash,
  getHashArrayValue,
  arrayChangeNameValue,
  reset_searchStrObject,
  list_paging,
  list_sort,
  re_load,
  search_form_dsp,
  toggle_searchbox,
  hideNewsArea,
  showNewsArea,
  onClickAddToCartButton,
};




// WEBPACK FOOTER //
// ./es6/admin-common-js/legacy/main.js